import React from "react";
import PredictionPage from "../../components/PredictionPage";

function USDCAD() {
  return (
    <PredictionPage
      title="USDCAD"
      content="This is the USDCAD AI Trading Predictions page."
      canonical="/forex-majors/usdcad-ai-trading-predictions"
      categoryKey="nav.forexMajors"
      categoryPath="/forex-majors"
      symbol="USDCAD"
    />
  );
}

export default USDCAD;
